import { Component, Input, OnInit, inject } from '@angular/core';
import { NZ_MODAL_DATA } from 'ng-zorro-antd/modal';

interface SamplingSupplyWarning {
    name: string;
    totalQuantity: number;
    requiredQuantity: number;
}

interface IModalData {
    warnings: SamplingSupplyWarning[];
}

@Component({
    selector: 'app-sampling-supply-warning-modal',
    templateUrl: './sampling-supply-warning-modal.component.html',
    styleUrls: ['./sampling-supply-warning-modal.component.scss']
})
export class SamplingSupplyWarningModalComponent implements OnInit {

    modalData: IModalData = inject(NZ_MODAL_DATA);
    warnings: SamplingSupplyWarning[] = [];

    totalExtraKits = 1;

    constructor() { }

    ngOnInit() {
        this.warnings = this.modalData.warnings ?? [];
        this.totalExtraKits = this.warnings.reduce((total, warning) => total += (warning.totalQuantity - warning.requiredQuantity), 0);
    }

}
